<nav class="ui-sidebar-nav" [class.ui-sidebar-nav--collapsed]="collapsed">
  <div class="ui-sidebar-nav__section" *ngFor="let section of filteredSections">
    <div class="ui-sidebar-nav__section-title" *ngIf="!collapsed">{{ section.title }}</div>
    <ul class="ui-sidebar-nav__list">
      <li *ngFor="let item of section.items">
        <a
          class="ui-sidebar-nav__item"
          [class.ui-sidebar-nav__item--active]="isActive(item.path)"
          href="javascript:void(0)"
          [title]="collapsed ? item.label : ''"
          (click)="onNavClick(item.path)">
          <mat-icon class="ui-sidebar-nav__icon">{{ item.icon }}</mat-icon>
          <span class="ui-sidebar-nav__label" *ngIf="!collapsed">{{ item.label }}</span>
        </a>
      </li>
    </ul>
  </div>
</nav>
